import { Component, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { TherapistApiService } from '@therapist/shared/services/api/therapist-api.service';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'sana-tp-password-request-reset',
  imports: [
    ReactiveFormsModule,
    RouterLink
  ],
  templateUrl: './password-request-reset.component.html',
  styleUrl: './password-request-reset.component.scss'
})
export class PasswordRequestResetComponent {

  readonly #fb = inject(FormBuilder);
  readonly #userApiService = inject(TherapistApiService);
  readonly #router = inject(Router);

  isSubmitted = signal(false);
  isSubmitting = signal(false);

  readonly currentYear = new Date().getFullYear();

  passwordRequestForm = this.#fb.group({
    email: [null, [Validators.required, Validators.email]]
  });

  routeToLogin(): void {
    this.#router.navigate(['/login']);
  }

  /** Zurück zum Formular, die eingegebene Adresse bleibt erhalten */
  resend(): void {
    this.isSubmitted.set(false);
  }

  onSubmit(): void {
    this.isSubmitted.set(false);

    this.passwordRequestForm.markAsTouched();

    if (this.passwordRequestForm.invalid) {
      return;
    }

    this.isSubmitting.set(true);

    this.#userApiService
      .requestPasswordReset(this.passwordRequestForm.controls.email.value!)
      .subscribe(reset => {
        this.isSubmitted.set(true);
        this.isSubmitting.set(false);
      });
  }
}
